/**
 * Returns a US phone number in E.164 format
 */
export const toUSPhoneNumber = (phoneNumber: string) => {
  const digits = phoneNumber.replace(/\D/g, '')

  if (digits.length === 10) return '+1' + digits
  if (digits.length === 11 && digits.startsWith('1')) return '+' + digits

  throw new Error('Invalid phone number')
}
